var $95cb1d7d72a197ba$exports = {};
$95cb1d7d72a197ba$exports = {
    "backButton": (args)=>`G\xe5 tilbake til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Utilgjengelig, utvid for detaljer`
};


export {$95cb1d7d72a197ba$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
